class UrlHelper {
	static isLinkTheSameAsCurrentUrl(linkToCheck) {
		if (!linkToCheck) {
			return false;
		}

		const linkToCheckUrl = new URL(linkToCheck);
		const redirectLinkUrlStr = linkToCheckUrl.protocol + '//' + linkToCheckUrl.host + linkToCheckUrl.pathname;

		const currentUrl = new URL(window.location.href)
		const currentUrlStr = currentUrl.protocol + '//' + currentUrl.host + currentUrl.pathname;

		return redirectLinkUrlStr === currentUrlStr;
	}

	/**
	 * Adds a parameter to a URL.
	 *
	 * @param {string} url - The URL to add the parameter to.
	 * @param {string} paramName - The name of the parameter to add.
	 * @param {string} param - The value of the parameter to add.
	 * @returns {string} The URL with the added parameter.
	 */
	static addParam(url, paramName, param) {
		const urlInstance = new URL(url);
		urlInstance.searchParams.append(paramName, param);

		return urlInstance.href;
	}

	static getParam(url, paramName, defaultValue = null) {
		const urlInstance = new URL(url);

		const param = urlInstance.searchParams.get(paramName);

		return param === undefined || param === null ? defaultValue : param;
	}

	static removeParamFromCurrentUrl(paramToRemove) {
		const urlInstance = new URL(window.location.href);
		urlInstance.searchParams.delete(paramToRemove);

		window.history.replaceState({}, document.title, urlInstance.href);
	}

	/**
	 * The replaceDeeplinkFamily method is designed to modify a URL by replacing the "deeplink family" portion with a new one.
	 * The "deeplink family" refers to the string that identifies a specific vendor
	 * or product category within the /go/vendor/.../ part of a URL or /go/vendor/.../769/ part of a URL, where 769 is
	 * a specific vendorId.
	 * @param {string} url
	 * @param {string} newDeeplinkFamily
	 * @param {number} vendorId
	 * @return {{newUrl: string, originalDeeplinkFamily: null|string}}
	 */
	static replaceDeeplinkFamily(url, newDeeplinkFamily, vendorId) {
		let originalDeeplinkFamily = '';
		const regex = new RegExp(`/go/vendor/([^/]+/)?${vendorId}/`, 'g');

		const newUrl = url.replace(regex, (match, capturedGroup) => {
			if (capturedGroup) {
				originalDeeplinkFamily = capturedGroup.replace('/', '');
			}

			return newDeeplinkFamily === ''
				? `/go/vendor/${vendorId}/`
				: `/go/vendor/${newDeeplinkFamily}/${vendorId}/`;
		});

		return {newUrl, originalDeeplinkFamily};
	}

	static isGoVendor(url, vendorId) {
		const regEx = new RegExp(`/go/vendor/(.*)(${vendorId})/`);

		return regEx.test(url);
	}

	static getVendorIdFromGoVendorLink (url) {
		let matches = url.match(/\/go\/vendor\/([a-z_\-0-9]+\/)?(\d+)\//),
			id = '';

		if (matches !== null && typeof matches[2] !== 'undefined') {
			id = matches[2];
		}

		return id;
	}
}

export default UrlHelper;
